//custom hook
import { useQuery } from 'react-query'

const version = () => {
  let versionNumber = Math.random().toFixed(3)
  return versionNumber
}

export default function useQueryHtmlData(queryKey, URL) {

  let urlWithVersion = `${URL}`

  return useQuery(queryKey, () =>
    fetch(urlWithVersion).then(res =>
      res.text()
      , { refetchOnWindowFocus: false }
    ))
}
